export const transportationSchedule = {
  contents: [
    {
      title: "caption.transportation_schedule"
    }
  ],
  childEntries: {
    rows: [
      {
        id: "bus_tracker",
        url: "/bus-tracker",
        icon: "fas fa-map-marker-alt",
        contents: [
          {
            title: "caption.bus_tracker"
          }
        ]
      },
      {
        id: "bus",
        url: "/bus-schedule",
        icon: "fas fa-bus",
        contents: [
          {
            title: "caption.bus_schedule"
          }
        ]
      },
      {
        id: "air",
        url: "/air-schedule",
        icon: "fas fa-plane",
        contents: [
          {
            title: "caption.air_schedule"
          }
        ]
      },
      {
        id: "train",
        url: "/train-schedule",
        icon: "fas fa-subway",
        contents: [
          {
            title: "caption.train_schedule"
          }
        ]
      },
      {
        id: "traffic",
        url: "/traffic",
        icon: "fas fa-traffic-light",
        contents: [
          {
            title: "caption.traffic_map"
          }
        ]
      }
    ]
  }
};

export const myCards = {
  url: "/card-register",
  contents: [
    {
      title: "caption.my_cards"
    }
  ],
  childEntries: {
    rows: [
      {
        id: "card_register",
        url: "/card-register",
        contents: [
          {
            title: "caption.card_register"
          }
        ]
      },
      {
        id: "card_detail",
        url: "/card-detail",
        contents: [
          {
            title: "caption.card_detail"
          }
        ]
      }
    ]
  }
};
